var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1253 18.0596C15.7003 17.118 18.3337 13.868 18.3337 10.0013C18.3337 5.4013 14.6337 1.66797 10.0003 1.66797C4.44199 1.66797 1.66699 6.3013 1.66699 6.3013M1.66699 6.3013V2.5013M1.66699 6.3013H3.34199H5.36699",
    stroke: "#5F2120",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10C1.66699 14.6 5.40033 18.3333 10.0003 18.3333",
    stroke: "#5F2120",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportRefreshIcon);
export default __webpack_public_path__ + "static/media/reportRefreshIcon.6b608f648af7a096861093c1da518d45.svg";
export { ForwardRef as ReactComponent };